import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Form, Button } from "react-bootstrap";
import axios from "axios";
import { FaEnvelope, FaKey } from 'react-icons/fa'; // Import icons

const Admin = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

 
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email || !password) {
      setErrorMessage('Please enter both email/phone and password.');
      return;
    }

    setIsLoading(true);
    try {
      const response = await axios.post('https://sharedvision-partners.online/v1/API/Admin/admin.php', { email, password });
      console.log(response.data);  // Log the response data to debug
      setIsLoading(false);

      if (response.data.success) {
        if (response.data.user.role === 'admin') {
          localStorage.setItem('user', JSON.stringify(response.data.user));
          navigate('/Dashadmin', { state: { user: response.data.user } });
        } else {
          setErrorMessage('Access denied: Only admins can log in here.');
        }
      } else {
        setErrorMessage(response.data.message || 'Invalid credentials or user not found.');
      }
      
    } catch (error) {
      setIsLoading(false);
      if (error.response) {
        setErrorMessage(`Error: ${error.response.data.message || 'An error occurred while logging in. Please try again.'}`);
      } else {
        setErrorMessage('Network error. Please check your internet connection.');
      }
    }
  };

  return (
    <div className="container-fluid min-vh-100 d-flex justify-content-center align-items-center">
      <div className="row w-100">
        <div className="col-md-6 d-flex flex-column justify-content-center align-items-center p-4">
          <div className="login-form-container w-100 container p-4 shadow-lg rounded">
            <h2 className="text-center mb-4">Admin Login</h2>
            <Form onSubmit={handleSubmit} className="p-3">
              <Form.Group controlId="Email" className="mb-3">
                <div className="input-group mb-3">
                  <span className="input-group-text"><FaEnvelope className="fa-fw" /></span> {/* Use FaEnvelope here */}
                  <Form.Control
                    type="email"
                    placeholder="Enter email"
                    name="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="rounded-3 form-control"
                    aria-label="Email"
                  />
                </div>
              </Form.Group>

              <Form.Group controlId="formPassword" className="mb-4">
                <div className="input-group mb-3">
                  <span className="input-group-text"><FaKey className="fa-fw" /></span> {/* Use FaKey here */}
                  <Form.Control
                    type="password"
                    name="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="Enter your password"
                    className="rounded-3"
                    aria-label="Password"
                  />
                </div>
              </Form.Group>

              {errorMessage && (
                <div className="alert alert-danger mb-4" role="alert">
                  {errorMessage}
                </div>
              )}

              <Button type="submit" disabled={isLoading} variant="primary" className="w-100 py-2 rounded-3">
                {isLoading ? <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> : 'Login'}
                {isLoading && ' Logging in...'}
              </Button>
            </Form>

            <div className="text-center mt-1">
              <p><a href="/forgetPass" className="text-primary">Forget Password</a></p>
              <span className="text-muted">Don't have an account? </span>
              <a href="/register" className="text-primary">Sign Up</a>
            </div>

            <p><a href="/" className="text-primary">User Login</a></p> {/* Link to user login page */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Admin;
